// @flow
import * as React from 'react';
import classNames from 'classnames';

import Link from 'app/common/lib/link';

import styles from './BreadcrumbItem.module.scss';;


type Props = {
  href?: string,
  children: React.Node,
  active?: boolean,
}

const BreadcrumbItem = ({ href, children, active }: Props) => (
  (!href || active)
    ? <span className={classNames(styles.root, styles.nonLink)}>{children}</span>
    : <Link className={styles.root} to={href}>{children}</Link>
);

export default BreadcrumbItem;
